const MARK = `${process.env.PUBLIC_URL}/brand/logo-mark.png`;

export const LogoMark = ({ className = "h-10" }) => (
  <img src={MARK} alt="OGM — Official GTA Modder" className={`w-auto select-none ${className}`} draggable="false" />
);

export const Logo = ({ className = "" }) => (
  <span className={`flex items-center ${className}`}>
    <LogoMark className="h-12 md:h-14" />
  </span>
);
